import { render, staticRenderFns } from "./settings-ava-property-mapping-pane.vue?vue&type=template&id=2372a170&scoped=true"
import script from "./settings-ava-property-mapping-pane.vue?vue&type=script&lang=js"
export * from "./settings-ava-property-mapping-pane.vue?vue&type=script&lang=js"
import style0 from "./settings-ava-property-mapping-pane.vue?vue&type=style&index=0&id=2372a170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2372a170",
  null
  
)

export default component.exports